import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// import VueI18n from 'vue-i18n'
import en from 'vuetify/lib/locale/en'
// import it from 'vuetify/lib/locale/it'
// import it from './i18n.js'
import getTraduzioni from './i18n.js'

Vue.use(Vuetify);

/* export default new Vuetify({
  lang: {
    locales: { it, en }, // async () => await getTraduzioni()
    current: 'it'
    // t: (key, ...params) => i18n.t(key, params)
  }
});
 */
export default async function() {
  const it_default = await getTraduzioni('default')
  const it = await getTraduzioni('it')
  // Inserire le altre traduzioni quando necessarie
  return new Vuetify({
    lang: {
      locales: { it, en },
      fallback: { it_default },
      current: 'it'
      // t: (key, ...params) => i18n.t(key, params)
    }
  });
}